import moment from "moment";
import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { viewJobSelector } from "./selector";
import {
  getOcccurrenceViewVariableRateDetails,
  getRatePerHour,
  updateJobInfoDetails,
} from "./action";
import useConfiguration from "../../hooks/useConfiguration";
import { getIncentiveMarkup } from "../JobOpportunity/action";
import { jobOpportunitySelector } from "../JobOpportunity/selector";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./index.css";
import { payRateTypeObj } from "../../helpers/data";
import { formatNumberWithCommas, formatNumberWithoutCommas, handleDecimalValueOnOnChange } from "../../helpers/regEx";
const ViewJobInfo = (props) => {
  // const [shiftamount, setShiftAmpunt] = useState(0);
  const [total, setTotal] = useState(0);
  const { shift, jobInfo, occurrenceViewVariableRate } =
    useSelector(viewJobSelector);
  const dispatch = useDispatch();
  const config = useConfiguration();
  const { incentiveMarkup } = useSelector(jobOpportunitySelector);

  //console.log(props.save, '----------');

  // useEffect(() => {
  //   // console.log('trgger----12-----')
  //   if (props?.jobDateToDisplay && shift?.startTime && shift?.endTime) {
  //     // console.log('time', props?.jobDateToDisplay, shift?.startTime?.id, shift?.endTime?.id)
  //     // hh:mm:ss a
  //     let startTime = '';
  //     let endTime = '';
  //     // console.log(shift?.startTime?.name?.split(' ')[1])
  //     const start = moment(shift?.startTime?.id, "hh:mm:ss").format("hh:mm:ss A")
  //     const end = moment(shift?.endTime?.id, "hh:mm:ss").format("hh:mm:ss A")
  //     const startAmPM = start.split(' ')[1];
  //     const endAmPM = end.split(' ')[1];
  //     //  console.log(startAmPM, endAmPM)
  //     if (startAmPM === 'PM' && endAmPM === 'AM') {
  //       startTime = moment(props?.jobDateToDisplay + ' ' + shift?.startTime?.id, "MM/DD/YYYY hh:mm:ss");
  //       endTime = moment(props?.jobDateToDisplay + ' ' + shift?.endTime?.id, "MM/DD/YYYY hh:mm:ss").add(1, 'days');
  //       //console.log('inside after -- time', startTime, endTime);
  //     } else {
  //       startTime = moment(props?.jobDateToDisplay + ' ' + shift?.startTime?.id, "MM/DD/YYYY hh:mm:ss");
  //       endTime = moment(props?.jobDateToDisplay + ' ' + shift?.endTime?.id, "MM/DD/YYYY hh:mm:ss");
  //     }
  //     // const startTime = moment(shift?.startTime?.id, "hh:mm:ss");
  //     // const endTime = moment(shift?.endTime?.id, "hh:mm:ss");
  //     const duration = moment.duration(endTime.diff(startTime));
  //     // console.log('duration', duration)
  //     if (duration?._data && (duration?._data?.hours || duration?._data?.minutes) && props?.billingrate) {
  //       // console.log('hours', duration?._data?.hours);
  //       // console.log('min', duration?._data?.minutes / 60);
  //       // console.log('totalhours', (duration?._data?.hours + (duration?._data?.minutes / 60)))
  //       const val = props?.billingrate * (duration?._data?.hours + (duration?._data?.minutes / 60));
  //       //console.log('shiftamo', val);
  //       if (val) {
  //         setShiftAmpunt(val?.toFixed(2))
  //       }

  //     }
  //     //console.log('after -- time', startTime, endTime);
  //     // console.log('diff', duration?._data)
  //   }
  // }, [props?.billingrate, shift?.startTime, props?.jobDateToDisplay, shift?.endTime])

  useEffect(() => {
    // console.log('trgger---------')
    // console.log(props?.incentivee, 'trigger')
    if (props.shiftamount) {
      const totalval =
        (jobInfo?.incentive ? parseFloat(jobInfo?.incentive) : 0) +
        parseFloat(props.shiftamount);
      if (totalval) {
        setTotal(totalval?.toFixed(2));
      }
    }
  }, [props.shiftamount, jobInfo?.incentive]);

  const updateValue = (target) => {
    // var validNumber = new RegExp(/^\d*\.?\d*$/);
    // //console.log(target.value);
    // if (validNumber.test(target.value) && target.value?.length <= 7) {
    //   dispatch(updateJobInfoDetails("incentive", target.value));
    // }
    const value = target?.value;
    const removeExistComma = formatNumberWithoutCommas(value);
    const decimalConversion = handleDecimalValueOnOnChange(removeExistComma);
    if (decimalConversion.length <= 7) {
      dispatch(updateJobInfoDetails("incentive", decimalConversion));
    }
  };
  useEffect(() => {
    if (
      props?.save &&
      config.baseUrl &&
      props?.locationId &&
      shift?.startTime?.id &&
      shift?.endTime?.id &&
      shift.date
    ) {
      const params = {
        locationId: props?.locationId,
        jobCategoryId: props?.jobCategoryId,
        startTime: shift?.startTime?.id,
        endTime: shift?.endTime?.id,
        shiftDate: shift.date,
      };
      dispatch(getRatePerHour({ url: config.baseUrl, params }));
    }
  }, [shift?.startTime?.id, shift?.endTime?.id, shift.date, props?.locationId]);

  // get Incentive Markup
  useEffect(() => {
    if (config.baseUrl && props?.employerJobLocationsList.at(0)?.locationId && props?.locationId && props?.jobCategoryId && props?.jobDate) {
      const IncentiveMarkupParams = {
        locationId: props?.employerJobLocationsList.at(0)?.locationId ?? props?.locationId,
        jobCategoryId: props?.jobCategoryId,
        shiftDate:props?.jobDate ? `${props?.jobDate}Z` :""
      };
      dispatch(
        getIncentiveMarkup(
          `${config.baseUrl}`,
          IncentiveMarkupParams,
          parseInt(props?.recursionFlag)
        )
      );
    }
  }, [config, props?.locationId, props?.employerJobLocationsList.at(0)?.locationId, props?.jobCategoryId, props?.recursionFlag,props?.jobDate]);

  // useEffect(() => {
  //   if (config.baseUrl && props?.hourlyBillingRateToDisplay === "Variable" && props?.startTime && props?.endTime && props?.jobCategoryId && props?.locationId && (shift.date || props?.jobDateToDisplay)) {
  //     const params = {
  //       locationId: props?.locationId,
  //       jobCategoryId: props?.jobCategoryId,
  //       startTime: props?.startTime,
  //       endTime: props?.endTime,
  //       shiftDate: shift.date ? shift.date : props?.jobDateToDisplay
  //     };
  //     config.baseUrl &&
  //       dispatch(getOcccurrenceViewVariableRateDetails({ url: config.baseUrl, params }));
  //   }
  // }, [config.baseUrl, props?.hourlyBillingRateToDisplay, props?.startTime, props?.endTime, props?.jobCategoryId, props?.locationId, shift.date, props?.jobDateToDisplay]);
  // console.log({occurrenceViewVariableRate});
  const payRates = (
    <Popover style={{ zIndex: "99999999999999" }} id="popover-basic">
      <Popover.Body>
        <table className="table table-responsive">
          <thead>
            <tr>
              <th className="text-capitalize">Start Time</th>
              <th className="text-capitalize">End Time</th>
              <th className="text-capitalize">Candidate Rate</th>
              <th className="text-capitalize">Billing Rate</th>
            </tr>
          </thead>
          <tbody>
            {occurrenceViewVariableRate?.occurrenceViewPayRate?.map(
              (item, index) => {
                console.log({ occurrenceViewVariableRate });

                return (
                  <tr className="border-bottom mt-2 bg-white">
                    <td>
                      {moment(item?.shiftStartTime, "hh:mm").format("hh:mm A")}
                    </td>
                    <td>
                      {moment(item?.shiftEndTIme, "hh:mm").format("hh:mm A")}
                    </td>
                    <td>{item?.hourlyPayRate}</td>
                    <td>{item?.totalRate}</td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </Popover.Body>
    </Popover>
  );
  return (
    <>
      <div className="row">
        <div className="d-flex">
          {/* <div className="col-3">
            <label className="form-label">Shift Title:</label>
            <label htmlFor={props?.jobTitle}>{props.jobTitle}</label>
          </div> */}
          {/* <div className="col-3">
            {!props?.save &&
            props?.hourlyBillingRateToDisplay === "Variable" ? (
              <>
              </>
            ) : props?.save && props?.billingrate === "Variable" ? (
              <>
                <label className="form-label"> Pay Rate :</label>
                {props?.claimedCandidateInfo?.isClaimed && (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={payRates}
                  >
                    <i
                      class="fa fa-question-circle"
                      style={{
                        fontSize: "15px",
                        marginTop: "4px",
                        cursor: "pointer",
                      }}
                      aria-hidden="true"
                    ></i>
                  </OverlayTrigger>
                )}
              </>
            ) : (
              ""
            )}
          </div> */}
        </div>
      </div>
      <div className="row">
        <div className="d-flex">
          <div className="col-3">
            <label className="form-label">Incentive:</label>
            {props.save ? (
              <label htmlFor={props?.incentive}>
                <div
                  style={{ position: "relative" }}
                  className="d-flex align-items-center default-checkbox"
                >
                  {jobInfo?.incentive ? (
                    <span style={{ position: "absolute", left: "10px" }}>
                      $
                    </span>
                  ) : (
                    ""
                  )}
                  <input
                    type="text"
                    className="form-control disbleclass"
                    placeholder="Enter Incentive Amount"
                    value={jobInfo?.incentive ? formatNumberWithCommas(jobInfo?.incentive) :""}
                    onChange={(event) => updateValue(event.target)}
                  />
                </div>
              </label>
            ) : (
              <label htmlFor={props?.incentive}>
                {`$`} {props?.incentive}
              </label>
            )}
          </div>
          <div className="col-3">
            <label className="form-label"> Incentive Billing Amount :</label>
            <label htmlFor="total">
            {jobInfo?.incentive  ? `$ ${formatNumberWithCommas((jobInfo?.incentive * incentiveMarkup).toFixed(2))}`:""}
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewJobInfo;
